module.exports = __webpack_public_path__ + "static/img/bg-fr.04f9c9bc.png";